import React from "react";
import megaPhone from "../assets/img/MagePhone.png"
import welcome from "../assets/img/welcome.png"
import revenueGrouth from "../assets/img/revenue-growth.png"
import data from "../assets/img/Data.png"
import sales from "../assets/img/Sales.png"
import visitor from "../assets/img/Visitor.png"

const HeroSection = () => {
  // console.log("SAAS: ",process.env.REACT_APP_BACKEND_URL," Chat: ",process.env.REACT_APP_CHAT_BACKEND_URL);
  
  return (
    <div className="container-fluid hero-section text-center">
      <h1 className="micro-animations">
        The Only <span className="highlight">All In One</span> SaaS App with B2C & B2B Solutions <br />
        Integrated Email, Chat & Advanced Analytics.
      </h1>
      <p className="hero-subtext mt-3 text-black">
        Boost efficiency and engagement with our B2C & B2B SaaS, driving higher conversions, faster responses, and AI-powered insights for better decision-making and ROI.
      </p>
      <div className="cta-buttons mt-4">
        <button className="btn-epic-x btn-primary shadow">Get Started For Free</button>
        <button className="btn-epic-x btn-contact shadow">Contact Sales</button>
      </div>
      <div className="illustrations text-center hide-on-tablet hide-on-mobile mt-5">
        <div className="illustration">
          <img src={megaPhone} alt="Megaphone" className="hero-left" />
        </div>
        <div className="illustrations-grid">
          {[
            { src: welcome, alt: "Welcome", className: "welcome" },
            { src: revenueGrouth, alt: "Revenue Growth", className: "revenue" },
            { src: data, alt: "Data Analytics", className: "data" },
            { src: sales, alt: "Sales Stats", className: "sales" },
            { src: visitor, alt: "Daily Visitor", className: "visitor" },
          ].map((item, index) => (
            <div className="illustration-item" key={index}>
              <img src={item.src} alt={item.alt} className={item.className} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
